import type { RagStatus } from '@/services/ownerIntelligence.service';

export type SignalTier = 'excellent' | 'healthy' | 'watch' | 'at_risk' | 'critical';

export function scoreToSignalTier(score: number): SignalTier {
  if (score > 95) return 'excellent';
  if (score >= 85) return 'healthy';
  if (score >= 70) return 'watch';
  if (score >= 50) return 'at_risk';
  return 'critical';
}

export function ragToSignalTier(status: RagStatus): SignalTier {
  if (status === 'green') return 'healthy';
  if (status === 'amber') return 'watch';
  return 'at_risk';
}

export function signalTierColor(tier: SignalTier): string {
  switch (tier) {
    case 'excellent':
    case 'healthy':
      return 'var(--oi-emerald)';
    case 'watch':
      return 'var(--oi-amber)';
    case 'at_risk':
    case 'critical':
      return 'var(--oi-crimson)';
    default:
      return 'var(--oi-text-muted)';
  }
}

export function signalTierLabel(tier: SignalTier): string {
  switch (tier) {
    case 'excellent':
      return 'EXCELLENT';
    case 'healthy':
      return 'HEALTHY';
    case 'watch':
      return 'WATCH';
    case 'at_risk':
      return 'AT RISK';
    case 'critical':
      return 'CRITICAL';
    default:
      return String(tier).toUpperCase();
  }
}
